import React from 'react';

import { Text } from '@betterment/samba-react';
import { Button, Modal } from '@betterment/style-closet-react';

interface Props {
  closeHandler: () => void;
}

const LockedCardModal: React.FC<React.PropsWithChildren<Props>> = ({ closeHandler }) => {
  return (
    <Modal variant="new" contentWidth={['100%', '600px']} closeHandler={closeHandler}>
      <Modal.Slot name="heading">Cannot activate card</Modal.Slot>
      <Modal.Slot name="content">
        <Text as="p" css={{ marginBottom: 'space.200', _last: { marginBottom: 'space.0' } }}>
          You cannot activate a new debit card if your existing debit card is locked.
        </Text>
      </Modal.Slot>
      <Modal.Slot name="actions">
        <Button onClick={closeHandler}>Got it</Button>
      </Modal.Slot>
    </Modal>
  );
};

export default LockedCardModal;
